import { inferEnvFromHostname } from '@custom/dx3';

const fromEnv = process.env.AUTH_ENV;

export const AUTH_ENVIRONMENT =
  fromEnv === 'qa' || fromEnv === 'pprd' ? fromEnv : inferEnvFromHostname();
